import { useEffect } from 'react';
import { trackViewItem } from './dispatch';
import type { TrackedOffer } from './types';

/** Reports the pack page's offer as viewed. Dedupe lives in trackViewItem,
 *  so a new object for the same pack costs nothing. */
export function useTrackViewItem(offer: TrackedOffer | null): void {
  useEffect(() => {
    if (offer) trackViewItem(offer);
  }, [offer]);
}
